import request from "@/utils/request";
// params是添加到url的请求字符串中的，用于get请求。
// data是添加到请求体（body）中的， 用于post请求。

export function register(data) {
  return request({
    url: "/h5/member/register",
    method: "post",
    data
  });
}
export function login(data) {
  return request({
    url: "/h5/member/login",
    method: "post",
    data
  });
}
export function memberInfo() {
  return request({
    url: "/h5/member",
    method: "get",
    params: {}
  });
}

export function findPwdEmailSend(params) {
  return request({
    url: "/h5/member/find/pwd/email",
    method: "get",
    params: params
  });
}

export function findPwd(data) {
  return request({
    url: "/h5/member/find/pwd",
    method: "post",
    data
  });
}
export function modifyPwd(data) {
  return request({
    url: "/h5/member/pwd/modify",
    method: "post",
    data
  });
}

export function modifyBaseInfo(data) {
  return request({
    url: "/h5/member/base/modify",
    method: "post",
    data
  });
}

export function modifyAuthentication(data) {
  return request({
    url: "/h5/member/authentication",
    method: "post",
    data
  });
}

export function getList(data) {
  return request({
    url: "/getList",
    method: "get",
    params: data
  });
}

export function testCreateTitle(params) {
  return request({
    url: "/h5/test/create/title",
    method: "get",
    params: params
  });
}

export function testCreateContent(params) {
  return request({
    url: "/h5/test/create/content",
    method: "get",
    params: params
  });
}

export function getCreateContent(params) {
  return request({
    url: "/h5/test/content/get",
    method: "get",
    params: params
  });
}

// 收入列表 
export function incomeList(data) {
  return request({
    url: "/h5/member/income/list?pageNum=" + data.pageNum,
    method: "get",
  });
}
// 提现记录列表
export function withdrawalList(data) {
  return request({
    url: "/h5/member/withdrawal/list?pageNum=" + data.pageNum,
    method: "get",
  });
}
// 推荐人列表
export function recommendList(data) {
  return request({
    url: "/h5/member/recommend/list?pageNum=" + data.pageNum,
    method: "get",
  });
}
//  提现
export function withdrawal(data) {
  return request({
    url: "/h5/member/withdrawal?amount=" + data.amount,
    method: "post",
  });
}
//  获取佣金比例
export function getRecommendRate() {
  return request({
    url: "/h5/member/recommend/rate",
    method: "get",
  });
}
//  获取积分规则
export function getPointRole() {
  return request({
    url: "/h5/sys/article/point-role",
    method: "get",
  });
}



// WEBPACK FOOTER //
// ./src/api/index.js